/* eslint-disable camelcase */
import React from 'react'
import { Link } from 'react-router-dom'
import './style.scss'

export const CardVenue = (props) => {
  const {
    foto_portada,
    nombre,
    ubicacion,
    nombre_organizador,
    fecha,
    capacidad,
    vid
  } = props

  return (
    <Link to={`/venue/${vid}`}>
    <div className="card border-card card-event bg-black text-light">
        <div className="img-wrapper zoom">
          <img src={foto_portada} className="card-img-top" alt={nombre} />
        </div>
        <div className="card-body card-event-body">
          <h5
            className="card-title card-event-title text-light mb-0">
            {nombre}
          </h5>
          <div className="card-event-data">
            <p className="d-flex align-items-center fw-bold text-decoration-none mt-1 mb-n2">{fecha}</p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              {ubicacion}
            </p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              {capacidad === null ? 'Capacidades' : 'Capacidad ' + capacidad + ' personas'}
            </p>
          </div>
        </div>
      </div>
      </Link>
  )
}
